import dayjs from 'dayjs'
import { useGetContactById, useGetProfileById, usePaginateNotes } from '@hooks'

// What the note editor shows about the person of a note: who they are, when
// you last talked, and how many other notes you have on them (the same lists
// as the Perso / Partagé tabs of their profile). `currentNoteId` is the note
// being written: it is not one of « les autres ».
export const useNotePerson = (contactId: string, currentNoteId?: string) => {
  const { data: contact } = useGetContactById(contactId)
  const { data: profile } = useGetProfileById(contactId)
  const personalNotes = usePaginateNotes({ contactId, type: 'personal' })
  const sharedNotes = usePaginateNotes({ contactId, type: 'shared' })
  const countsCurrent =
    !!currentNoteId &&
    [...personalNotes.flatData, ...sharedNotes.flatData].some((n) => n.id === currentNoteId)

  return {
    name: contact?.fullName ?? '',
    avatarUrl: contact?.avatarUrl,
    hashtags: contact?.hashtags ?? [],
    lastExchange: profile?.lastInteractionAt ? dayjs(profile.lastInteractionAt).fromNow() : null,
    otherNotesCount: Math.max(
      0,
      personalNotes.totalCount + sharedNotes.totalCount - (countsCurrent ? 1 : 0),
    ),
  }
}
